import routes from './routes'
import { Fetch } from '../fetch'

class UserInformationService {
  async getUserInformation () {
    return Fetch('get', routes.UserInformation)
  }

  async changeUserEmail (externalToken) {
    return Fetch('post', routes.ChangeEmail, null, { externalToken })
  }

  async updateUserInfo (payload) {
    return Fetch('put', routes.UpdateUserInfo, payload)
  }

  async updateUserPhoto (payload) {
    return Fetch('patch', routes.UpdateUserPhoto, payload, { contentType: 'multipart/form-data' })
  }

  async updateUserPassword (payload) {
    return Fetch('post', routes.ChangePassword, payload)
  }
}

export default new UserInformationService()
